import { useState, useEffect, useCallback } from "react";
import Pagination from "components/common/pagination";
import { apiPost } from "apis/api";
import axios from "axios";

interface ParentProps  {
  strType : string;
  strProductBrandCode: string;
}

interface ProductItem {
  TotalPageCount: number;
  TotalCount: number;
  StartPage: number;
  ProductCode: string;
  ProductName: string;
  ProductStatus: string;
  ProductSalePrice: number;
  ProductCapacity: string;
  ProductSort: number;
  ProductImgUrl?: string;  
}

// ─── API 호출 ─────────────────────────────────────────────────────
const fetchBrandProducts = async (
  strType: string,
  strProductBrandCode: string,
  intPage: number,
  intPageSize: number  
): Promise<ProductItem[]> => {
  const response = await apiPost('/product/getProductBrandList', { strType, intPage, intPageSize, strProductBrandCode }) as { resultList: ProductItem[] };
  /*
  const {data} = await axios.post<{ resultList: ProductItem[] }>(
    "/product/getProductBrandList",
    { strType, intPage, intPageSize, strProductBrandCode }
  );
  */
 //console.log(response);
  return response.resultList ?? [];
};

const BrandList = ({strType, strProductBrandCode}: ParentProps) => {
  //console.log("strProductBrandCode " + strProductBrandCode);
  const [productList, setProductList] = useState<ProductItem[]>([]);
  const [loading,     setLoading]       = useState(false);
  const [error,         setError]       = useState<string | null>(null);

  const [intPage,       setIntPage]       = useState(1);
  const [totalCount, setTotalCount]       = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [startPage,     setStartPage]     = useState(0);
  const intPageSize = 8;
  
  // 브랜드 탭 변경 시 페이지 초기화
  useEffect(() => {
    setIntPage(1);
  }, [strProductBrandCode]);

  const loadProducts = useCallback(async () => {
    // 브랜드 코드 없으면 스킵
    if (!strProductBrandCode || strProductBrandCode === "00") {
      console.log("▶ 조기 리턴 - brandCode:", strProductBrandCode); // ✅ 여기서 걸리는지 확인
      return;
    }

    setLoading(true);
    setError(null);

    try {
      //console.log("strProductBrandCode ::: " + strProductBrandCode);

      const list = await fetchBrandProducts(strType, strProductBrandCode, intPage, intPageSize);

      setProductList(list);

      if (list.length > 0) {
        setTotalPageCount(list[0].TotalPageCount);
        setTotalCount(list[0].TotalCount);
        setStartPage(list[0].StartPage);
      } else {
        setTotalPageCount(0);
        setTotalCount(0);
        setStartPage(0);
      }

    } catch (err) {
      console.error("상품 목록 조회 실패:", err);
      setError("상품 목록을 불러오지 못했습니다.");
    } finally {
      setLoading(false);
    }
    // ✅ strProductBrandCode 변경 시 자동으로 재호출
  }, [strType, strProductBrandCode, intPage, intPageSize]);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);
  
  // ─── 로딩 상태 ──────────────────────────────────────────────────
  if (loading) {
    return (
      <div className="brand-list-loading" >
        <div className="loading-spinner" />
        <span>상품을 불러오는 중...</span>
      </div>
    );
  }

  // ─── 에러 상태 ──────────────────────────────────────────────────
  if (error) {
    return (
      <div className="brand-list-error">
        <div>
          <span>{error}</span><br/>
          <button onClick={loadProducts}>다시 시도</button>
        </div>
      </div>
    );
  }

  // ─── 빈 목록 ────────────────────────────────────────────────────
  if (productList.length === 0) {
    return (
      <div className="brand-list-empty">
        <span>등록된 상품이 없습니다.</span>
      </div>
    );
  }
  
  return (
    <div className="container">
      <div className={`container-img-grid col4`}>
        {productList.map((product) => (
          <div className="img-style" key={product.ProductCode}>
            {product.ProductImgUrl && (
              <div className="img-inner bgF7F7F7">
                <img src={product.ProductImgUrl} alt={product.ProductName} />
              </div>
            )}            
            <div className="img-text">
              <span className="fontbold" >{product.ProductName}</span><br/>{product.ProductCapacity}
              <br/> 가격 : {product.ProductSalePrice.toLocaleString()}원
            </div>
          </div>
        ))}
      </div>
      
      <div>
        <Pagination  intPage={intPage} intPageSize={intPageSize} totalPageCount={totalPageCount} startPage={startPage} setIntPage={setIntPage} />
      </div>
    </div>
  );
};

export default BrandList;
